import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import * as _unitOfWork from "./api";
import "./App.css";
import Loading from "./components/common/Loading";
import BaseLayout from "./components/layout/BaseLayout";
import useAuth from "./contexts/authContext";
import { flatRoutes, staticPath } from "./router/routerConfig";
import { socket } from "./socket";
import { STORAGE_KEY } from "./utils/constant";
import './config-translation'
import { flatUnAuthenConfig } from "./router/routeUnAuthenConfig";
const Login = lazy(() => import("./pages/auth/Login"));
function App() {
  const [loadingFirst, setLoadingFirst] = useState(true);
  const {
    isAuthenticated,
    user,
    updateBranchs,
    permissionByUser,
    setCompanySetting,
  } = useAuth();
  useEffect(() => {
    if (window.innerWidth <= 768) {
      window.location.replace(`https://m.medicmms.vn`);
    }
  }, []);
  useEffect(() => {
    if (isAuthenticated) {
      fetchApp();
      fetchUserPermission();
      _unitOfWork.user.updateLastLoginTime();
    } else {
      setLoadingFirst(false);
    }
  }, [isAuthenticated]);

  // useEffect(() => {
  //   if (isAuthenticated && user && (user.id || user._id)) {
  //     const userId = user.id || user._id;
  //     socket.connect();

  //     socket.on("connect", () => {
  //       // console.log("Socket connected! ID:", socket.id);
  //       // alert("Socket connected! ID:", socket.id);
  //       socket.emit("join", userId);
  //     });

  //     return () => {
  //       socket.off("connect");
  //       socket.disconnect();
  //     };
  //   }
  // }, [isAuthenticated, user]);

  const fetchDataUser = async () => {
    let res = await _unitOfWork.user.getDataUser();
    if (res && res.code === 1) {
      let _newBranchs = res.data.userBranchs.map((item) => item.branch);
      updateBranchs(_newBranchs);
      setCompanySetting(res.data.companySetting);
      // localStorage.setItem(STORAGE_KEY.PERMISSION, JSON.stringify(res.data.permissions.map(item => item.permission)));
      localStorage.setItem(
        STORAGE_KEY.COMPANY_SETTING,
        JSON.stringify(res.data.companySetting),
      );
    }
  };
  const fetchUserPermission = async () => {
    let res = await _unitOfWork.user.getPermissisonByUsers();
    if (res && res.code === 1) {
      permissionByUser(res.data);
    }
  };
  const fetchApp = async () => {
    await fetchDataUser();
    setLoadingFirst(false);
  };
  if (loadingFirst) {
    return <Loading />;
  }
  if (isAuthenticated === undefined) {
    return <Loading />;
  } else if (isAuthenticated === false) {
    return (
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/login" element={<Login />} index />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="*" element={<Navigate to="/login" replace />} />
          {flatUnAuthenConfig.map((item) => {
            return (
              <Route
                path={item.path}
                element={<item.component />}
                key={item.path}
              />
            );
          })}
        </Routes>
      </Suspense>
    );
  }
  // if (permissions && permissions.length > 0)
  else {
    return (
      <div className="App">
        <BaseLayout>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route
                path="*"
                element={<Navigate to={staticPath.home} replace />}
              />
              {flatRoutes().map((item) => {
                return (
                  <Route
                    path={item.path}
                    element={<item.component />}
                    key={item.key}
                  />
                );
              })}
              {flatUnAuthenConfig.map((item) => {
                return (
                  <Route
                    path={item.path}
                    element={<item.component />}
                    key={item.path}
                  />
                );
              })}
            </Routes>
          </Suspense>
        </BaseLayout>
        {/* <Loadder></Loadder> */}
      </div>
    );
  }
}
export default App;
